import { Debouncer, DebounceTypes } from "../../common/debouncer"
import { EventRouter } from "../../common/events"

export const cssViewportUnitVarsUpdate = new EventRouter<void>("cssViewportUnitVarsUpdate", { reportIfNoListeners: false })

// Sets and maintains css --vh and --vw vars to be 1% of their respective actual visual viewport dimensions.
// Excludes things like the address bar, virtual keyboard, or the home bar that some androids (samsung only?)
// have at the bottom of the screen
export function initCssViewportUnitVarsHandling(): void {
    updateCssViewportUnitVars()

    const resizeDebouncer = new Debouncer(updateCssViewportUnitVars, { bounceLimitMS: 100, debounceType: DebounceTypes.debounce })
    window.visualViewport?.addEventListener("resize", () => resizeDebouncer.callFunc())
    // Fallback for edge cases where the resize event may fail to fire
    window.setInterval(() => resizeDebouncer.callFunc(), 500)
}

function updateCssVhVar(): void {
    const prevVh = document.documentElement.style.getPropertyValue("--vh")
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight
    const newVh = `${viewportHeight * 0.01}px`
    if (newVh !== prevVh) {
        document.documentElement.style.setProperty("--vh", newVh)
        cssViewportUnitVarsUpdate.fire()
    }
}

function updateCssVwVar(): void {
    const prevVw = document.documentElement.style.getPropertyValue("--vw")
    const viewportWidth = window.visualViewport?.width ?? window.innerWidth
    const newVw = `${viewportWidth * 0.01}px`
    if (newVw !== prevVw) {
        document.documentElement.style.setProperty("--vw", newVw)
        cssViewportUnitVarsUpdate.fire()
    }
}

function updateCssViewportUnitVars(): void {
    updateCssVhVar()
    updateCssVwVar()
}
